<template>
  <div v-if="hasAccess" class="py-4 container-fluid">
    <div class="card">
      <div class="card-header py-3">
        <div class="row align-items-center">
          <div class="col-4">
            <h5 class="mb-0">UNSPSC</h5>
          </div>
          <div class="col-4 d-flex justify-content-center">
            <IconField class="w-100">
              <InputIcon>
                <i class="pi pi-search"></i>
              </InputIcon>
              <InputText
                v-model="table.search"
                type="text"
                size="small"
                placeholder="Search"
                class="rounded-pill w-100"
                @keyup="filter"
              />
            </IconField>
          </div>
          <!-- Hapus tombol Add -->
        </div>
      </div>
      <div style="height: 500px; overflow-y: auto;">
        <DataTable
          :value="table.onLoad ? dummyRows : table.data"
          class="datatable-sm text-sm"
          removable-sort
          scrollable
          scroll-height="flex"
          table-style="min-width: 50rem"
        >
          <Column field="code" header="Code" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.code ? slotProps.data.code : '' }}
            </template>
          </Column>
          <Column field="level" header="Level" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.level ? slotProps.data.level : '' }}
            </template>
          </Column>
          <Column field="parent_code" header="Parent Code" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.parent_code ? slotProps.data.parent_code : '' }}
            </template>
          </Column>
          <Column field="identity_relation_code" header="Identity Relation Code" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.identity_relation_code ? slotProps.data.identity_relation_code : '' }}
            </template>
          </Column>
          <Column field="title" header="Title" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.title ? slotProps.data.title : '' }}
            </template>
          </Column>
          <Column field="definition" header="Definition" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.definition ? slotProps.data.definition : '' }}
            </template>
          </Column>
          <template #empty>
            <div style="text-align: center; padding: 40px 0;">
              <img src="/no_data.png" alt="No Data" style="max-width: 330px; opacity: 0.7; margin-bottom: 0;" />
              <div style="color: #888; font-size: 1.1em; font-weight: 500;">
                No Data
              </div>
            </div>
          </template>
        </DataTable>
      </div>
      <div class="card-footer pb-0 d-flex justify-content-between align-items-center">
        <BasePagination
          v-model="table.page.current_pages"
          :page-count="table.page.total_pages || 1"
          size="sm"
          @click="changePage()"
        />
        <p>
          {{ (table.page.current_pages - 1) * table.page.per_pages + table.data.length }} of {{ table.total }}
        </p>
      </div>
    </div>
    <!-- Hapus DialogPrime modal -->
  </div>
  <NoAccess v-else />
</template>

<script>
import { mapState } from "vuex";
import BasePagination from "@/components/BasePagination.vue";
import NoAccess from "@/components/NoAccess.vue";
import api from "@/helpers/api";
import unspscService from "@/services/dictionary/unspscService";

export default {
  components: {
    BasePagination,
    NoAccess,
  },
  computed: {
    ...mapState({
      authUserPermissions: (state) => state.auth.userHasPermissions || [],
    }),
    hasAccess() {
      return this.authUserPermissions.includes('unspsc-view');
    },
  },
  data() {
    return {
      table: {
        onLoad: true,
        search: this.$route.query.search || "",
        total: 0,
        data: [],
        limit: 100,
        page: {
          current_pages: 1,
          per_pages: 10,
          total_pages: 1,
        },
        loadTimeout: null,
      },
      dummyRows: Array.from({ length: 10 }, () => ({})),
    };
  },
  mounted() {
    if (this.hasAccess) {
      this.get();
    }
  },
  methods: {
    async get() {
      this.table.onLoad = true;
      try {
        const response = await api(
          this,
          unspscService.list({
            search: this.table.search,
            limit: this.table.limit,
            page: this.table.page.current_pages,
          }),
          false
        );
        const paged = response.data || {};
        this.table.data = paged.data || [];
        this.table.total = paged.total || (paged.data ? paged.data.length : 0);
        this.table.page.total_pages = paged.last_page || 1;
        this.table.page.current_pages = paged.current_page || 1;
        this.table.page.per_pages = paged.per_page || this.table.limit;
      } catch (error) {
        this.table.data = [];
        this.table.total = 0;
        this.table.page.total_pages = 1;
      } finally {
        this.table.onLoad = false;
      }
    },
    filter() {
      clearTimeout(this.table.loadTimeout);
      this.table.loadTimeout = setTimeout(() => {
        this.$router.push({ query: this.table.search ? { search: this.table.search } : null });
        this.table.page.current_pages = 1;
        this.get();
      }, 500);
    },
    changePage() {
      this.get();
    },
  },
};
</script>